<template>
  <div>
    <navbar></navbar>
    <gd-aside></gd-aside>
    <main class="gd-main gd-bckg-very-light-grey">
      <div class="gd-lad-view">
        <div class="gd-lad-view__left-part">
          <metadata-adder
            ref='adder'
            :location="image.croppedLocation"
            :croppedSrcRef="image.imgCrop"
            v-if="active && !isLoading">
          </metadata-adder>
        </div>
        <div class="gd-lad-view__file-viewer">
          <div v-if="!active">
            <div class="gd-lad-view__title
            gd-text-center
            gd-bold
            gd-medium-padding-layout
            gd-big-typo"
                 v-if="!currentFileType">
              Définissez le type de fichier que vous voulez paramétrer :
              <div class="gd-medium-padding-layout">
                <select
                  class="gd-input-text"
                  id="searchByType"
                  @change="updateCurrentFileType($event.target.value)">
                  <option value="" selected disabled="">-- Sélectionnez un type --</option>
                  <option
                    :value="type.id"
                    v-for="type in fileTypes"
                    :key="`searchOption${type.id}`">
                    {{ type.description }}
                  </option>
                </select>
              </div>
            </div>
            <div class="gd-lad-view__title
            gd-text-center
            gd-bold
            gd-medium-padding-layout
            gd-big-typo"
                 v-else>
              <div class="gd-medium-padding-layout gd-big-typo">
                Configuration du type :
                {{ fileTypes[fileTypes
                .findIndex(elmt => elmt.id === currentFileType)].description }}
              </div>
              Définissez les paramètres de votre parapheur à partir d'un fichier modèle :
              <div class="gd-medium-padding-layout">
                <label
                  for="fileUpload"
                  class="gd-file-input__label gd-file-viewer__file-input">
                  Choisir un fichier
                </label>
                <input
                  id="fileUpload"
                  type="file"
                  class="gd-file-input__input"
                  accept="application/pdf"
                  v-on:change="onFileInputChange">
              </div>
            </div>
          </div>
          <div v-else-if="isLoading">
            LOADER !!!!
          </div>
          <file-viewer ref='viewer'
                       :autoCrop="this.conf !== undefined"
                       :image="image" v-else></file-viewer>
        </div>
        <lad-right :metadatas="resources.metadatas"
                   :configurationName="configurationName"
                   v-if="active && !isLoading"></lad-right>
      </div>
    </main>
  </div>
</template>

<script>
import PDFJS from 'pdfjs-dist';
import { mapActions } from 'vuex';
import Aside from '@/components/Aside';
import Navbar from '@/components/Navbar';
import LADRight from '@/components/LADRight';
import FileViewer from '@/components/FileViewer';
import MetadataAdder from '@/components/MetadataAdder';

import { eventBus } from '../main';

export default {
  name: 'lad',
  props: ['conf', 'fileType', 'file'],
  components: {
    'gd-aside': Aside,
    Navbar,
    'lad-right': LADRight,
    FileViewer,
    MetadataAdder,
  },

  data() {
    return {
      configurationUpdate: undefined,
      active: false,
      files: [],
      image: { src: '', imgCrop: '', croppedLocation: {}, width: '', height: '' },
      isLoading: false,
      currenPdfPage: 0,
      currentFileType: undefined,
      fileTypes: [],
      configurationName: '',
      resources: {
        typeCode: 'FACT',
        metadatas: [],
      },
    };
  },

  created() {
    eventBus.$on('addMetadata', () => {
      this.buildCropper();
    });
  },

  methods: {
    ...mapActions({
      apiSaveMetadatas: 'lad/saveMetadatas',
      apiGetFileTypes: 'lad/getFileTypes',
      getApiParseurs: 'lad/getParseurs',
    }),

    resetFile() {
      this.files = [];
      this.active = false;
    },

    onFileInputChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      this.loadFile(files);
    },
    loadFile(files) {
      console.log(files);
      const thiis = this;
      const fileReader = new FileReader();

      if (!files.length) {
        return;
      }
      this.active = true;
      this.files = files;

      fileReader.onload = () => {
        PDFJS.GlobalWorkerOptions.workerSrc = './pdfjs-dist/build/pdf.worker.js';
        PDFJS.getDocument(fileReader.result).then((pdf) => {
          thiis.$refs.viewer.setImageSrc(pdf);
          thiis.isLoading = false;
          thiis.disableExistingFileTypes();
        }, (error) => {
          console.log(error);
        });
      };

      fileReader.readAsArrayBuffer(files[0]);
    },
    deleteMeta(meta) {
      const indexTag = this.resources.metadatas
        .findIndex(el => el.metadata.tagName === meta.metadata.tagName);
      if (indexTag !== -1) {
        this.resources.metadatas.splice(indexTag, 1);
      }
    },
    updateMetadata(metaTagName) {
      const indexTag = this.resources.metadatas
        .findIndex(el => el.metadata.tagName === metaTagName);

      if (indexTag !== -1) {
        const meta = this.resources.metadatas[indexTag];
        this.image.croppedLocation = Object.assign({}, meta.location);
        this.$refs.viewer.cropIt(Object.assign({}, meta.location));

        this.$refs.adder.applyConfForUpdate(meta);
      }
    },
    saveMetadatas(configurationName) {
      this.apiSaveMetadatas({
        name: configurationName,
        fileType: this.currentFileType,
        metadatas: this.resources.metadatas,
        id: (this.configurationUpdate === undefined) ? undefined : this.configurationUpdate.id,
      })
        .then((data) => {
          if (data.status === 200) {
            const fiile = Object.assign([], this.files);
            this.files = [];
            this.active = false;
            this.configurationUpdate = undefined;
            this.resources.metadatas = [];
            this.configurationName = '';
            this.$router.push({ name: 'ladHome', params: { file: fiile } });
          }
        });
      for (let key = 0; key < this.resources.metadatas.length; key += 1) {
        if (Object.prototype.hasOwnProperty.call(this.resources.metadatas, key)) {
          const currentValue = this.resources.metadatas[key];
          currentValue.tagName = currentValue.metadata.tagName;
          delete currentValue.metadata;
          delete currentValue.testedValue;
        }
      }
    },
    disableExistingFileTypes() {
      // eslint-disable-next-line arrow-body-style
      const arr = this.resources.metadatas.map((metadata) => { return metadata.metadata.tagName; });
      this.$refs.adder.applyDisableForUpdate(arr);
    },
    updateCurrentFileType(fileType) {
      console.log(fileType);
      this.currentFileType = fileType;
    },
  },

  mounted() {
    this.apiGetFileTypes()
      .then((data) => {
        this.getApiParseurs()
          .then((parseurs) => {
            const fileTypesList = data.data.data;

            for (let i = 0; i < parseurs.metadatas.length; i += 1) {
              const indexExistingType = data.data.data.findIndex(elmt => elmt.id ===
                parseurs.metadatas[i].fileType);
              if (indexExistingType > -1) {
                // fileTypesList.splice(indexExistingType, 1);
              }
            }
            fileTypesList.sort((a, b) => {
              if (a.description < b.description) return -1;
              if (a.description > b.description) return 1;
              return 0;
            });
            this.fileTypes = fileTypesList;

            /* pour le fichier en memoire */
            if (this.file !== undefined) {
              this.loadFile(this.file);
            }
            /* !!!
            pour l'udpate des configurations
            !!! */
            if (this.conf && this.fileType) {
              this.currentFileType = this.fileType;
              this.configurationName = this.conf.name;
              this.resources.metadatas = this.conf.metadatas.map((meta) => {
                const x = {};
                x.metadata =
                  { friendlyName: meta.friendlyName, isDisable: true, tagName: meta.tagName };
                x.location = meta.location;
                x.pageNumber = meta.pageNumber;
                x.testedValue = '';
                x.hasRegex = (meta.regex !== undefined);
                x.hasPrefix = (meta.prefix !== undefined);
                x.regexValue = (meta.regex !== undefined) ? meta.regex : '';
                x.prefixValue = (meta.prefix !== undefined) ? meta.prefix : '';
                x.transformPatterns = meta.transformPatterns;
                return x;
              });

              this.configurationUpdate = this.conf;
            }
          });
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/LADView.vue